import React from 'react';
import { StyleSheet, Text } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { CalcScreen, CategoryCard } from '../../components/shell';
import { C, FONT, SP } from '../../theme/tokens';

type Calc = { title: string; description: string; screen: string };

const CALCS: Calc[] = [
  { title: 'Mixed Air Temperature', description: 'Mixed air dry-bulb from outside and return air', screen: 'AirflowMixedAirTemperature' },
  { title: 'Mixed Air Enthalpy', description: 'Mixed air enthalpy from outside and return air', screen: 'AirTemperatureMixedAirEnthalpy' },
  { title: 'Outside Air Percentage', description: 'Outside air fraction from temperature or enthalpy', screen: 'AirTemperatureOutsideAirPercentage' },
  { title: 'Psychrometrics', description: 'Dew point, RH, wet bulb, and enthalpy', screen: 'PsychrometricsDewPointEnthalpy' },
  { title: 'Mixed Air (Psychrometrics)', description: 'Psychrometric mixed air state', screen: 'PsychrometricsMixedAir' },
  { title: 'Total Heat Transfer', description: 'Total heat transferred across an air or water stream', screen: 'HeatTransferHeatTransferTotal' },
  { title: 'Sensible Heat Transfer', description: 'Sensible heat from mass flow and ΔT', screen: 'HeatTransferSensibleHeatTransfer' },
  { title: 'Latent Heat Transfer', description: 'Latent heat from humidity ratio change', screen: 'HeatTransferLatentHeatTransfer' },
  { title: 'Sensible Heat Ratio', description: 'Sensible / total heat ratio', screen: 'HeatTransferSensibleHeatRatio' },
  { title: 'Q BTU/h', description: 'Quick heat load in BTU/h', screen: 'HeatTransferQBtuh' },
];

export default function TABTemperatureScreen() {
  const nav = useNavigation();
  return (
    <CalcScreen title="Temperature & Heat Transfer" subtitle="TAB · Temperature, psychrometrics, heat transfer">
      <Text style={styles.sectionLabel}>Calculations</Text>
      {CALCS.map((c) => (
        <CategoryCard
          key={c.screen}
          title={c.title}
          description={c.description}
          cta="Open →"
          onPress={() => nav.navigate(c.screen as never)}
        />
      ))}
    </CalcScreen>
  );
}

const styles = StyleSheet.create({
  sectionLabel: {
    fontFamily: FONT.sans,
    fontSize: 12,
    color: C.dim,
    textTransform: 'uppercase',
    letterSpacing: 0.6,
    marginBottom: SP.sm,
  },
});
